import PropTypes from 'prop-types';
import FJImageExtenderCreations from '../view/FJImageExtenderCreations';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';
import FJBlankInVideoPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';

const FJImageExtenderCreationsContainer = ({ active }) => {
    const dispatch = useDispatch();
    const uploadImageInfo = useSelector(state => state.imageExtender.uploadImageInfo);

    const boardSize = useSelector(state => state.imageExtender.boardSize);
    const imageRect = useSelector(state => state.imageExtender.imageRect);
    const curRatioName = useSelector(state => state.imageExtender.curRatioName);

    const setImageRect = (rect, direction) => {
        dispatch(FJActionImageExtender.setImageRectAction(rect, direction));
    };

    return uploadImageInfo.src ? (
        <FJImageExtenderCreations
            active={active}
            uploadImageInfo={uploadImageInfo}
            boardSize={boardSize}
            imageRect={imageRect}
            setImageRect={setImageRect}
            curRatioName={curRatioName}
        />
    ) : (
        <FJBlankInVideoPanel active={active} />
    );
};

FJImageExtenderCreationsContainer.propTypes = {
    active: PropTypes.bool,
};

export default FJImageExtenderCreationsContainer;
